"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedtruck = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedtruck` : '') + (description ? ` desc-brandedtruck` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedtruck"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedtruck"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M61 12.6c0-1.99-1.42-3.6-3.16-3.6H26.17C24.42 9 23 10.61 23 12.6v31.94c0 .26.18.46.4.46l22.91-.47.09-.01 4.6-.97c.65.43 3.95.96 4 .97l5.54.4c.24.05.46-.16.46-.44V12.6Z",
    fill: "#F9D29F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.29 45.2V24.24c-2.63 0-8.77.23-13.04.86-4.17.62-6.17 12.64-7.28 19.6-.04.26.17.5.43.5h19.89v-.02Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23 44.99V24c-2.59 0-8.63.23-12.83.87-4.1.61-6.06 12.62-7.16 19.61-.04.27.14.52.4.52H23v-.01Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 24h-1v20h1V24Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 39c0-.27-.2-.5-.44-.5h-3.12c-.24 0-.44.22-.44.5s.2.5.44.5h3.12c.24 0 .44-.22.44-.5Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 37V27c-1.56 0-5.2.1-7.73.42-2.4.29-3.6 5.73-4.26 9.09-.05.26.15.49.41.49H20Z",
    fill: "#DAFCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 41.35c0-.2-.22-.35-.48-.35H3.48c-.26 0-.48.16-.48.35v1.3c0 .2.22.35.48.35h3.04c.26 0 .48-.16.48-.35v-1.3Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M60.46 11A82.03 82.03 0 0 1 23 44.6c-.1 1.64.43 1.13 1.2 1.25h35.55c.69 0 1.24.45 1.24-.21V12.87a3.78 3.78 0 0 0-.54-1.87Z",
    fill: "#EDBC7C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M62 45.5c0-.83-.71-1.5-1.58-1.5H3.58C2.71 44 2 44.66 2 45.5c0 .83.71 1.49 1.58 1.49h6.36l.56-1.17a2.8 2.8 0 0 1 1.8-1.47l1.7-.34h2.13l1.93.55c.6.22 1.1.61 1.43 1.13l.82 1.3H44.5c1.07 0 .5-1.1 1.5-1.65 1-1.1 2.43-1.11 3.15-1.33h1.64c-2 0 .71 0 0 0l2.21.79c.64.22 2 2.2 2 2.2h5.42c.87 0 1.58-.66 1.58-1.5Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m36 22 6.5-4.88L49 22V9H36v13Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M49.5 55a6.47 6.47 0 0 0 6.5-6.5 6.5 6.5 0 1 0-6.5 6.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M49.5 51.37a2.86 2.86 0 0 0 2.63-1.76 2.9 2.9 0 0 0 0-2.17 2.93 2.93 0 0 0-1.54-1.54 2.82 2.82 0 0 0-3.1.62 2.82 2.82 0 0 0 0 4.01c.53.53 1.26.84 2 .84Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.5 55a6.47 6.47 0 0 0 6.5-6.5 6.5 6.5 0 1 0-6.5 6.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.5 51.37a2.86 2.86 0 0 0 2.63-1.76 2.9 2.9 0 0 0 0-2.17 2.93 2.93 0 0 0-1.54-1.54 2.82 2.82 0 0 0-3.1.62 2.82 2.82 0 0 0 0 4.01c.53.53 1.26.84 2 .84Z",
    fill: "white"
  }));
};
var _default = exports.default = brandedtruck;